import ScreenLock from '../__utils/screenLock';
import Search from '../__page/Search';
import MenuMobile from './MenuMobile';

const $ = jQuery.noConflict();

class HeaderMobile {
    constructor() {
        this.body = $('body');
        this.header = $('.main-header');
        this.menu = this.header.find('.main-header__menu-mobile');
        this.menuTrigger = this.header.find('.main-header__menu-mobile-trigger');
        this.form = this.header.find('.main-header__form--mobile');
        this.formTrigger = this.header.find('.main-header__mobile-link--cye');
        this.formBack = this.form.find('.main-header__form-back');

        // Variables
        this.mq = window.matchMedia('(max-width: 1199px)');
    }

    init() {
        this.resized();

        this.menuTrigger.on('click', this.toggleMenu.bind(this));
        this.formBack.on('click', () => {
            this.form.removeClass('active');
        });
        this.formTrigger.on('click', () => {
            this.form.addClass('active');
        });

        this.mq.addListener((mq) => {
            if (!mq.matches) this.closeMenu();
        });
    }

    toggleMenu() {
        if (this.menuTrigger.hasClass('active')) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.body.addClass('menu-open');
        Search.closeSearch();
        ScreenLock.lock();
        this.menuTrigger.addClass('active');
        this.menu.addClass('active');
        this.setMenuHeight();
    }

    closeMenu() {
        this.body.removeClass('menu-open');
        this.menuTrigger.removeClass('active');
        this.menu.removeClass('active');
        MenuMobile.hideMegaMenu();
        ScreenLock.unlock();
    }

    setMenuHeight() {
        if (!this.mq.matches) {
            return;
        }

        const height = window.innerHeight - this.header.outerHeight();

        this.menu.css('height', height);
    }

    resized() {
        this.setMenuHeight();
    }
}

export default new HeaderMobile();
